import React from "react";
import {
  Inbox,
  LayoutGrid,
  PieChart,
  ShieldCheck,
} from "lucide-react";
import Navbar from "../Navbar";
import WelcomeBanner from "./WelcomeBanner";
import StatsStrip from "./StatsStrip";
import WidgetCard from "./WidgetCard";
import Config from "../../Config";
import { UserAuth } from "../../context/AuthContext";
import "./home.css";

const HomePage = () => {
  const { user } = UserAuth();

  const OPTIONS = [
    {
      id: 1,
      text: "Service Management",
      Icon: Inbox,
      path: Config.TicketExternalLink || "/manage-ticket",
      accent: "teal",
      desc: "Review and resolve service-management tickets",
      cta: "Open Queue",
    },
    {
      id: 2,
      text: "Operator Hub",
      Icon: LayoutGrid,
      path: Config.OperatorHubExternalLink || "/operator-hub/",
      accent: "teal",
      desc: "Operator workstation for classification, indexing and QA",
      cta: "Open Workstation",
      external: true,
    },
    {
      id: 3,
      text: "Analytics Dashboard",
      Icon: PieChart,
      path: Config.AnalyticsExternalLink,
      accent: "navy",
      desc: "Review Analytics",
      cta: "Open Reports",
      external: true,
    },
    ...(user?.isAdmin
      ? [
          {
            id: 4,
            text: "Admin Access Controls",
            Icon: ShieldCheck,
            path: Config.TicketExternalLink || "/admin/users",
            accent: "amber",
            desc: "Manage Users and Admin Settings",
            cta: "Open Admin",
            external: false,
          },
        ]
      : []),
  ];

  return (
    <div className="home-page">
      <Navbar />
      <WelcomeBanner />
      <main className="home-main">
        <div className="home-main__inner">
          <StatsStrip />
          {OPTIONS.length > 0 ? (
            <div className="home-options-grid">
              {OPTIONS.map((option) => (
                <div key={option.id} className="widget-card">
                  <WidgetCard {...option} />
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center">
              <p className="text-gray-500 text-xl">No widgets available.</p>
            </div>
          )}
        </div>
      </main>
      <footer className="home-footer">
        <span>&copy; {new Date().getFullYear()} SPS Global &middot; HIVE</span>
      </footer>
    </div>
  );
};

export default HomePage;
